export default "__VITE_ASSET__b004b00c__"